class PhoneValidator {
  constructor(country) {
    this.validCountry = ["ru", "kz"];
    this.country = country;
    /**
     * Код ошибки при валидации
     * @type {"federal" | "length" | "ru" | "kz" | "incorrect" | null}
     */
    this.error = null;
  }

  /**
   * Проверка корректности страны указанного номера
   * @returns {boolean} - валидная ли указана страна номера
   */
  IsValidCountry() {
    if (this.validCountry.indexOf(this.country) === -1) return false;
    return true;
  }

  /**
   * Проверка является ли номер телефона федеральным
   * @param {string} number - номер телефона
   * @returns {boolean} - является ли номер федеральным
   */
  isFederalRuNumber(number) {
    return number.startsWith("7800") || number.startsWith("7804");
  }

  /**
   * Проверка корректности номера телефона
   * @param {string} phoneNumber - номер телефона
   * @param {{ federalNumber?: boolean } | undefined} options - дополнительные опции валидации
   * @returns {boolean} - валидный ли номер телефона
   */
  Valid(phoneNumber, options) {
    const { federalNumber = false } = options || {};
    const number = phoneNumber.replace(/[^\d]/g, "");

    /** Сбрасываем ошибку */
    this.error = null;

    /** Страна номера не допустима */
    if (!this.IsValidCountry()) {
      this.error = "incorrect";
      return false;
    }

    /** Длина номера не корректна */
    if (number.length !== 11) {
      this.error = "length";
      return false;
    }

    /** Номер российский */
    if (this.country === "ru") {
      /** Начинается не с 7 */
      if (number.charAt(0) !== "7") {
        this.error = "ru";
        return false;
      }

      /** Нужно ли проверять федеральные номера и это они */
      if (federalNumber && this.isFederalRuNumber(number)) {
        this.error = "federal";
        return false;
      }

      return true;
    }

    /** Номер казахский */
    if (this.country === "kz") {
      /** Начинается не с 77 и не с 76 */
      if (!(number.startsWith("77") || number.startsWith("76"))) {
        this.error = "kz";
        return false;
      }

      return true;
    }

    this.error = "incorrect";
    return false;
  }

  /**
   * Показ тостера с текстом ошибки
   * @return {void}
   */
  showPhoneError() {
    switch (this.error) {
      case "federal":
        toastr.error("Федеральные номера 8-800 и 8-804 нельзя использовать в настройках ВАТС");
        break;
      case "length":
        toastr.error("Введите номер полностью");
        break;
      case "ru":
        toastr.error("Введите российский номер");
        break;
      case "kz":
        toastr.error("Введите казахский номер");
        break;
      case "incorrect":
        toastr.error("Некорректный номер телефона");
        break;
      default:
        break;
    }

    this.error = null;
  }
}

export default PhoneValidator;
